<div class="content">
  <div class="content-panel">


    <ul ngbNav #nav="ngbNav" class="nav-tabs" activeId="tab-0">
      <ng-container *ngFor="let type of typesUtilisateurs; let index = index">
        <li ngbNavItem="{{'tab-'+index}}">
          <a ngbNavLink>{{type.libelle}}</a>
          <ng-template ngbNavContent>
            <app-search-bar [(value)]="searchStrings[index]"></app-search-bar>
            <table class="table table-striped liste" aria-label="Liste des droits">
              <thead>
              <tr>
                <ng-container *ngTemplateOutlet="tableHeader;context:{sortProperty:'libelle', libelle:'page.admin.profils.table.header.profil'}"></ng-container>
                <ng-container *ngTemplateOutlet="tableHeader;context:{sortProperty:'service', libelle:'page.admin.profils.table.header.service'}"></ng-container>
                <ng-container *ngIf="type.nbSoustype > 1">
                  <ng-container *ngTemplateOutlet="tableHeader;context:{sortProperty:'soustype.libelle', libelle:'page.admin.profils.table.header.soustype'}"></ng-container>
                </ng-container>
                <th translate>page.admin.profils.table.header.droits-fonctionnels</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let profil of getProfilsByType(type.code) | filter : '*': searchStrings[index] | orderBy:order.property:order.reverse:true">
                <td>{{profil.libelle}}</td>
                <td [title]="profil.service.code">{{profil.service.libelleCourt}}</td>
                <td *ngIf="type.nbSoustype > 1" [title]="profil.soustype.code">{{profil.soustype.libelle}}</td>
                <td>
                  <button type="button" class="btn btn-light btn-show-droits" (click)="profil.__show_droits = !profil.__show_droits"><fa-icon [icon]="profil.__show_droits ? 'minus':'plus'"></fa-icon>{{(profil.__show_droits ? 'label.masquer':'label.afficher') | translate}}</button>
                  <div *ngIf="profil.__show_droits">
                    <table class="liste-droits" aria-label="Liste des droits">
                      <thead>
                        <tr>
                          <th scope="col" class="visually-hidden" translate>page.admin.profils.table.header.droit-fonctionnel</th>
                          <th scope="col" class="visually-hidden" translate>label.actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let droitFonctionnel of profil.droitsFonctionnels">
                          <td [title]="droitFonctionnel.code">{{droitFonctionnel.libelle}}</td>
                          <td class="actions-droits">
                            <fa-icon icon="trash" (click)="supprimerDroit(profil, droitFonctionnel)"></fa-icon>
                            <fa-icon icon="search" (click)="voirRoles(roleModal, droitFonctionnel)"></fa-icon>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="mb-3 ajout-droit">
                      <label class="form-label" translate>page.admin.profils.table.ajouter-droits</label>
                      <select class="form-select" [(ngModel)]="profil.__null" (ngModelChange)="ajouterDroit(profil, $event)">
                        <option [value]="null"></option>
                        <option *ngFor="let droit of getDroitsFonctionnelsAjoutables(profil)" [ngValue]="droit">{{droit.libelle}}</option>
                      </select>
                    </div>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </ng-template>
        </li>
      </ng-container>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-3"></div>
  </div>
</div>


<ng-template #tableHeader let-property="sortProperty" let-libelle="libelle">
  <th *ngIf="property" (click)="setOrder(property)" [class.sortable]="property">
    {{libelle | translate}}
    <fa-icon *ngIf="property" [icon]="getIcon(property)"></fa-icon>
  </th>
  <th *ngIf="!property">{{libelle | translate}}</th>
</ng-template>

<ng-template #roleModal let-modal>
  <div class="modal-header">
    <div class="modal-title">
      <h3>Roles : </h3>
      <h4>
        {{modalContext.title}}
      </h4>
    </div>
  </div>
  <div class="modal-body">
    <table class="table table-striped" aria-label="Liste des roles">
      <thead>
        <tr>
          <th scope="col" class="visually-hidden" translate>label.libelle</th>
          <th scope="col" class="visually-hidden" translate>label.code</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let role of modalContext.roles">
          <td>{{role.libelle}}</td>
          <td>({{role.code}})</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="modal.dismiss()" translate>label.valider</button>
  </div>
</ng-template>

